import { render, staticRenderFns } from "./VentilationIdentifiedModal.vue?vue&type=template&id=45512e40&scoped=true&"
import script from "./VentilationIdentifiedModal.vue?vue&type=script&lang=js&"
export * from "./VentilationIdentifiedModal.vue?vue&type=script&lang=js&"
import style0 from "./VentilationIdentifiedModal.vue?vue&type=style&index=0&id=45512e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45512e40",
  null
  
)

export default component.exports